import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import {  PATIENT_API } from '../../ApiNames';


export const fetchData1 = (family: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: family,
});
export const fetchData2 = (name: any) => ({
    type: 'FETCH_DATA2_SUCCESS',
    payload: name,
});





export const fetchFamilyData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,q:1};
            const apiname = PATIENT_API.family_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchName = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,q:3};
            const apiname = PATIENT_API.family_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};




